// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__performance--BGTJg {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}
.style__box--PLY7B {
  border: 3px solid #f1f2f4;
  border-radius: 0.5rem;
  padding: 1.5rem;
  background: #fff;
  margin: 2rem 0 2rem 2rem;
  height: calc(100% - 5rem);
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.style__userPage--az81f {
  height: 100%;
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.style__userDetails--wQQKN {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  flex: 1;
  overflow: hidden;
}
.style__tabContentArea--r1TSC {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.style__tabContentArea--r1TSC .style__userContentBox--h60Mu {
  flex: 1;
  min-height: 0;
}
.style__header--b5Xva {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.style__headerMain--g3OT6 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.style__headerMainRow--lQURp {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
  gap: 1rem;
}
.style__headerMainRow--lQURp > div:first-child {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}
.style__headerMainRow--lQURp .style__headerActions--ckMDO {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.style__headerAside--IW_OJ {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  gap: 1rem;
}
.style__headerAdminButtons--sSrpW {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
}
.style__headerLicenseDropdown--OKYBt {
  display: flex;
  width: 280px;
  min-width: 200px;
  max-width: 100%;
}
.style__headerInfo--zpLR4 {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.style__icon--PX86Q {
  color: #7d8287;
  cursor: pointer;
}
.style__scrollableUserContentBox--wO5bD {
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.style__userContentBox--h60Mu {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  overflow: hidden;
  width: 100%;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.style__userContentBox--h60Mu .simulationOverview .tabs {
  margin-bottom: 20px;
  border-bottom: 1px solid #e5e7eb;
}
.style__userContentBox--h60Mu .simulationOverview .tabs .tab {
  padding: 12px 24px;
  font-size: 14px;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}
.style__userContentBox--h60Mu .simulationOverview .tabs .tab:hover {
  color: #374151;
}
.style__userContentBox--h60Mu .simulationOverview .tabs .tab.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
}
.style__overview--hc7l1 {
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  width: 70%;
}
.style__headerInfo--zpLR4 {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.style__chartsContainer--n3kyF {
  display: flex;
  flex-direction: row;
  gap: 3rem;
  width: 100%;
  margin-top: 1rem;
}
.style__chartBox--FnfVG {
  flex: 1;
  width: 48%;
  max-width: 50%;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.style__smallBox--jlyl1 {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin: 0.125rem;
  width: 100%;
  box-sizing: border-box;
}
.style__simulationProgressPage--eBes5 {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem 0.5rem 2rem 0;
  box-sizing: border-box;
}
.style__simulationProgress--jZkGd {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__simulationProgressHeader--YOMVO {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.style__simulationProgressOverview--ol9ts {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.style__simulationProgressOverview--ol9ts > * {
  flex: 1 1 0;
  min-width: 20rem;
}
.style__simulationProgressSummary--vuDAU {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  border: 1px solid #e3e4e8;
  border-radius: 0.5rem;
  background: #fff;
}
.style__simulationProgressSummaryMain--_0j3A {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
}
.style__simulationProgressPercent--r55I4 {
  min-width: 6rem;
}
.style__simulationProgressSummaryText--tl6NU {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.style__simulationProgressLastCompleted--IBwl8 {
  color: #62656a;
}
.style__simulationProgressStrip--bma5Z {
  display: flex;
  gap: 2px;
  width: 100%;
  height: 0.75rem;
  border-radius: 0.25rem;
  overflow: hidden;
}
.style__simulationProgressSegment--AaOKL {
  flex: 1 1 0;
  min-width: 2px;
}
.style__simulationProgressStatusLabel--gsMXw {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.style__simulationProgressStatusDot--jNanW {
  flex: none;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
}
.style__simulationProgressStatusCompleted--cagcR {
  background: #00c561;
}
.style__simulationProgressStatusFailed--L3noS {
  background: #ff513d;
}
.style__simulationProgressStatusInProgress--LpVPu {
  background: #3892f3;
}
.style__simulationProgressStatusOpen--JiIVQ {
  background: #afb2b6;
}
.style__simulationProgressStatusLocked--oGOg2 {
  background: #e3e4e8;
}
.style__simulationProgressFilters--GfRzk {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.style__simulationProgressTable--JOMOL {
  width: 100%;
  border-collapse: collapse;
}
.style__simulationProgressTable--JOMOL th, .style__simulationProgressTable--JOMOL td {
  text-align: left;
  padding: 1rem 0.75rem;
  border-bottom: 1px solid #e3e4e8;
  vertical-align: middle;
}
.style__simulationProgressTable--JOMOL th {
  color: #62656a;
  font-family: 'Inter Medium', sans-serif;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.style__simulationProgressTable--JOMOL td:nth-child(2), .style__simulationProgressTable--JOMOL th:nth-child(2) {
  width: 12rem;
}
.style__simulationProgressTable--JOMOL td:nth-child(3), .style__simulationProgressTable--JOMOL th:nth-child(3) {
  width: 14rem;
}
.style__simulationProgressTable--JOMOL td:nth-child(4), .style__simulationProgressTable--JOMOL th:nth-child(4) {
  width: 6rem;
}
.style__simulationProgressErrors--fYF1K {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  border: 1px solid #e3e4e8;
  border-radius: 0.5rem;
  background: #fff;
}
.style__simulationProgressMeterList--FI7D8 {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.style__simulationProgressMeterRow--wkSDH {
  display: grid;
  grid-template-columns: minmax(8rem, 14rem) 1fr 3rem;
  align-items: center;
  gap: 1rem;
}
.style__simulationProgressMeterTrack--v1YY5 {
  height: 0.5rem;
  border-radius: 0.25rem;
  background: #f1f2f4;
  overflow: hidden;
}
.style__simulationProgressMeterFill--HWGGQ {
  height: 100%;
  border-radius: 0.25rem;
}
.style__simulationProgressErrorFill--E_m2D {
  background: #ff7c00;
}
.style__simulationProgressMeterCount--b5f2Y {
  text-align: right;
}
.style__simulationProgressLessonToggle--RmO8Q {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  color: inherit;
}
.style__simulationProgressLessonTitle--NdEJM {
  padding-left: calc(1rem + 0.25rem);
}
.style__simulationProgressLessonErrors--qNMwW td {
  background: #f9fafa;
  padding-left: calc(0.75rem + 1rem + 0.25rem);
}
.style__simulationProgressLessonErrorList--IOFIa {
  list-style: none;
  margin: 0.5rem 0 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: 0.5rem 1.5rem;
}
.style__simulationProgressLessonErrorList--IOFIa li {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}
.style__simulationOverview--u6uxf {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.style__simulationOverview--u6uxf .style__header--b5Xva {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.style__simulationOverview--u6uxf .style__simulationDrivesWrapper--Lmf3C {
  margin-top: 20px;
  height: calc(100vh - 300px);
  overflow-y: auto;
}
.style__headerWithDropdown--CdQpn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}
.style__overviewLayout--pKv8J {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.style__overviewContent--ap7r1 {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem 0.5rem 2rem 0;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}
.style__licenseSelectorContainer--KpUk7 {
  display: flex;
  width: 280px;
}
.style__drivesWrapper--mGvpp {
  overflow-y: scroll;
}
.style__theoryExamContainer--k4HJ2 {
  overflow-y: scroll;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
}
.style__theoryProgressContainer--tvEom {
  display: flex !important;
  flex-direction: row !important;
  gap: 12px;
  width: 100%;
  height: calc(100vh - 400px);
  overflow-y: auto;
  align-items: flex-start;
  flex-wrap: nowrap;
}
.style__theoryProgressContainer--tvEom > * {
  box-sizing: border-box !important;
  flex-grow: 0;
  flex-shrink: 0;
}
.style__theoryProgressContainer--tvEom > div:first-child {
  width: 58% !important;
  box-sizing: border-box !important;
}
.style__theoryProgressContainer--tvEom > div:last-child {
  width: 40% !important;
  box-sizing: border-box !important;
}
@media (max-width: 1520px) {
  .style__theoryProgressContainer--tvEom {
    display: block !important;
    height: auto !important;
  }
  .style__theoryProgressContainer--tvEom > div:first-child, .style__theoryProgressContainer--tvEom > div:last-child {
    width: 100% !important;
    display: block !important;
    margin-bottom: 20px;
  }
  .style__theoryProgressContainer--tvEom .topicOverview {
    width: 100% !important;
  }
  .style__theoryProgressContainer--tvEom > div:first-child > div:first-child {
    width: 100% !important;
  }
}
.style__scrollableContainer--eM5r9 {
  overflow-y: scroll;
}
.style__scrollableContainer--eM5r9::-webkit-scrollbar {
  width: 8px;
}
.style__scrollableContainer--eM5r9::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 4px;
}
.style__scrollableContainer--eM5r9::-webkit-scrollbar-thumb:hover {
  background-color: #a1a1a1;
}
.style__scrollableContainer--eM5r9::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
.style__cards--GeYof {
  display: flex;
  gap: 1rem;
  margin: 0.5rem 0.125rem;
}
`, "",{"version":3,"sources":["webpack://./../ds-admin/src/pages/UserPage/style.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAHJ;AAJA;EAWI,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAJJ;AAhBA;EAwBI,YAAA;EACA,aAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AALJ;AAxBA;EAiCI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,OAAA;EACA,gBAAA;AANJ;AAhCA;EA0CI,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAPJ;AAvCA;EAiDM,OAAA;EACA,aAAA;AAPN;AA3CA;EAuDI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AATJ;AAjDA;EA8DI,aAAA;EACA,mBAAA;EACA,8BAAA;AAVJ;AAtDA;EAoEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,8BAAA;EACA,SAAA;AAXJ;AA9DA;EA4EM,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAXN;AApEA;EAmFM,aAAA;EACA,mBAAA;EACA,SAAA;AAZN;AAzEA;EA0FI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;AAdJ;AAhFA;EAkGI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAfJ;AAtFA;EAyGI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAhBJ;AA5FA;EAgHI,aAAA;EACA,mBAAA;EACA,WAAA;AAjBJ;AAjGA;EAsHI,cAAA;EACA,eAAA;AAlBJ;AArGA;EA2HM,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAnBN;AA3GA;EAkII,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;AApBJ;AAtHA;EA8IQ,mBAAA;EACA,gCAAA;AArBR;AA1HA;EAkJU,kBAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;EACA,yBAAA;AArBV;AAuBU;EACE,cAAA;AArBZ;AAwBU;EACE,cAAA;EACA,4BAAA;AAtBZ;AAxIA;EAsKI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AA3BJ;AA9IA;EA6KI,aAAA;EACA,mBAAA;EACA,WAAA;AA5BJ;AAnJA;EAmLI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AA7BJ;AA1JA;EA2LI,OAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AA9BJ;AAnKA;EAqMI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AA/BJ;AA3KA;EA8MI,OAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;AAhCJ;AAtLA;EA0NI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjCJ;AA5LA;EAiOI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAlCJ;AAlMA;EAwOI,aAAA;EACA,eAAA;EACA,SAAA;AAnCJ;AAvMA;EA6OM,WAAA;EACA,gBAAA;AAnCN;AA3MA;EAmPI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AArCJ;AApNA;EA6PI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAtCJ;AA1NA;EAoQI,eAAA;AAvCJ;AA7NA;EAwQI,aAAA;EACA,sBAAA;EACA,YAAA;AAxCJ;AAlOA;EA8QI,cAAA;AAzCJ;AArOA;EAkRI,aAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AA1CJ;AA7OA;EA2RI,WAAA;EACA,cAAA;AA3CJ;AAjPA;EAgSI,aAAA;EACA,mBAAA;EACA,WAAA;AA5CJ;AAtPA;EAsSI,UAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AA7CJ;AA5PA;EA6SI,mBAAA;AA9CJ;AA/PA;EAiTI,mBAAA;AA/CJ;AAlQA;EAqTI,mBAAA;AAhDJ;AArQA;EAyTI,mBAAA;AAjDJ;AAxQA;EA6TI,mBAAA;AAlDJ;AA3QA;EAiUI,aAAA;EACA,eAAA;EACA,WAAA;AAnDJ;AAhRA;EAuUI,WAAA;EACA,yBAAA;AApDJ;AApRA;EA4UM,gBAAA;EACA,qBAAA;EACA,gCAAA;EACA,sBAAA;AApDN;AA3RA;EAmVM,cAAA;EACA,uCAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AArDN;AAlSA;EA4VM,YAAA;AAtDN;AAtSA;EAiWM,YAAA;AAvDN;AA1SA;EAsWM,WAAA;AAxDN;AA9SA;EA2WI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AA1DJ;AAvTA;EAqXI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AA3DJ;AA/TA;EA8XI,aAAA;EACA,mDAAA;EACA,mBAAA;EACA,SAAA;AA5DJ;AArUA;EAqYI,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AA7DJ;AA3UA;EA4YI,YAAA;EACA,sBAAA;AA9DJ;AA/UA;EAiZI,mBAAA;AA/DJ;AAlVA;EAqZI,iBAAA;AAhEJ;AArVA;EAyZI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAjEJ;AAhWA;EAqaI,kCAAA;AAlEJ;AAnWA;EAyaI,mBAAA;EACA,4CAAA;AAnEJ;AAvWA;EA8aI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,4DAAA;EACA,kBAAA;AApEJ;AA/WA;EAsbM,aAAA;EACA,8BAAA;EACA,SAAA;AApEN;AApXA;EA6bI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAtEJ;AA1XA;EAmcM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAtEN;AAjYA;EA2cM,gBAAA;EACA,2BAAA;EACA,gBAAA;AAvEN;AAtYA;EAkdI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AAzEJ;AA9YA;EA2dI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;AA1EJ;AAtZA;EAoeI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iCAAA;AA3EJ;AAlaA;EAifI,aAAA;EACA,YAAA;AA5EJ;AAtaA;EAsfM,kBAAA;AA7EN;AAzaA;EA0fQ,kBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AA9ER;AAjbA;EAmgBI,wBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AA/EJ;AA3bA;EA8gBM,iCAAA;EACA,YAAA;EACA,cAAA;AAhFN;AAhcA;EAqhBM,qBAAA;EACA,iCAAA;AAlFN;AApcA;EA2hBM,qBAAA;EACA,iCAAA;AApFN;AAwFI;EAAA;IACE,yBAAA;IACA,uBAAA;EArFJ;EAmFE;IAMI,sBAAA;IACA,yBAAA;IACA,mBAAA;EArFN;EA6EE;IAYI,sBAAA;EAtFN;EA0EE;IAgBI,sBAAA;EAvFN;AACF;AA1dA;EAsjBI,kBAAA;AAzFJ;AA7dA;EA2jBI,UAAA;AA3FJ;AAheA;EA+jBI,yBAAA;EACA,kBAAA;AA5FJ;AApeA;EAokBI,yBAAA;AA7FJ;AAveA;EAwkBI,yBAAA;AA9FJ;AA1eA;EA4kBI,aAAA;EACA,SAAA;EACA,uBAAA;AA/FJ","sourcesContent":["@import '@yaak/components/src/colors';\n@import '@yaak/components/src/spacing';\n\n:local {\n  .performance {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    width: 100%;\n  }\n\n  .box {\n    border: 3px solid @color-asphalt-grey-095;\n    border-radius: @spacing-50;\n    padding: @spacing-150;\n    background: @color-white;\n    margin: @spacing-200 0 @spacing-200 @spacing-200;\n    height: calc(100% - 5rem);\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n  }\n\n  .userPage {\n    height: 100%;\n    min-height: 0;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .userDetails {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0;\n    flex: 1;\n    overflow: hidden;\n  }\n\n  .tabContentArea {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    .userContentBox {\n      flex: 1;\n      min-height: 0;\n    }\n  }\n\n  .header {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    width: 100%;\n  }\n\n  .headerMain {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .headerMainRow {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    width: 100%;\n    justify-content: space-between;\n    gap: @spacing-100;\n\n    > div:first-child {\n      display: flex;\n      align-items: center;\n      gap: @spacing-75;\n      min-width: 0;\n    }\n\n    .headerActions {\n      display: flex;\n      flex-direction: row;\n      gap: @spacing-100;\n    }\n  }\n\n  .headerAside {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-shrink: 0;\n    gap: @spacing-100;\n  }\n\n  .headerAdminButtons {\n    display: flex;\n    flex-direction: row;\n    gap: 12px;\n    align-items: center;\n  }\n\n  .headerLicenseDropdown {\n    display: flex;\n    width: 280px;\n    min-width: 200px;\n    max-width: 100%;\n  }\n\n  .headerInfo {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-50;\n  }\n\n  .icon {\n    color: @color-asphalt-grey-050;\n    cursor: pointer;\n  }\n\n    .scrollableUserContentBox {\n      height: 100vh;\n      overflow-y: auto;\n      display: flex;\n      flex-direction: column;\n    }\n\n  .userContentBox {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-300;\n    overflow: hidden;\n    width: 100%;\n    padding: 20px;\n    background: @color-white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    :global(.simulationOverview) {\n      :global(.tabs) {\n        margin-bottom: 20px;\n        border-bottom: 1px solid #e5e7eb;\n\n        :global(.tab) {\n          padding: 12px 24px;\n          font-size: 14px;\n          color: #6b7280;\n          border-bottom: 2px solid transparent;\n          transition: all 0.2s ease;\n\n          &:hover {\n            color: #374151;\n          }\n\n          &:global(.active) {\n            color: #2563eb;\n            border-bottom-color: #2563eb;\n          }\n        }\n      }\n    }\n  }\n\n  .overview {\n    flex-grow: 1;\n    height: 100%;\n    overflow: hidden;\n    width: 70%;\n  }\n\n  .headerInfo {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-50;\n  }\n  \n  .chartsContainer {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-300;\n    width: 100%;\n    margin-top: @spacing-100;\n  }\n  \n  .chartBox {\n    flex: 1;\n    width: 48%;\n    max-width: 50%;\n    min-width: 400px;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n  }\n\n  .smallBox {\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    margin: @spacing-15;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .simulationProgressPage {\n    flex: 1;\n    min-height: 0;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: @spacing-100 @spacing-50 @spacing-200 0;\n    box-sizing: border-box;\n  }\n\n  .simulationProgress {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .simulationProgressHeader {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .simulationProgressOverview {\n    display: flex;\n    flex-wrap: wrap;\n    gap: @spacing-100;\n\n    > * {\n      flex: 1 1 0;\n      min-width: 20rem;\n    }\n  }\n\n  .simulationProgressSummary {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    padding: @spacing-150;\n    border: 1px solid @color-asphalt-grey-090;\n    border-radius: @spacing-50;\n    background: @color-white;\n  }\n\n  .simulationProgressSummaryMain {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: @spacing-150;\n  }\n\n  .simulationProgressPercent {\n    min-width: 6rem;\n  }\n\n  .simulationProgressSummaryText {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-25;\n  }\n\n  .simulationProgressLastCompleted {\n    color: @color-asphalt-grey-040;\n  }\n\n  .simulationProgressStrip {\n    display: flex;\n    gap: 2px;\n    width: 100%;\n    height: @spacing-75;\n    border-radius: @spacing-25;\n    overflow: hidden;\n  }\n\n  .simulationProgressSegment {\n    flex: 1 1 0;\n    min-width: 2px;\n  }\n\n  .simulationProgressStatusLabel {\n    display: flex;\n    align-items: center;\n    gap: @spacing-50;\n  }\n\n  .simulationProgressStatusDot {\n    flex: none;\n    width: @spacing-50;\n    height: @spacing-50;\n    border-radius: 50%;\n  }\n\n  .simulationProgressStatusCompleted {\n    background: @color-green-070;\n  }\n\n  .simulationProgressStatusFailed {\n    background: @color-red-060;\n  }\n\n  .simulationProgressStatusInProgress {\n    background: @color-blue-060;\n  }\n\n  .simulationProgressStatusOpen {\n    background: @color-asphalt-grey-070;\n  }\n\n  .simulationProgressStatusLocked {\n    background: @color-asphalt-grey-090;\n  }\n\n  .simulationProgressFilters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: @spacing-50;\n  }\n\n  .simulationProgressTable {\n    width: 100%;\n    border-collapse: collapse;\n\n    th,\n    td {\n      text-align: left;\n      padding: @spacing-100 @spacing-75;\n      border-bottom: 1px solid @color-asphalt-grey-090;\n      vertical-align: middle;\n    }\n\n    th {\n      color: @color-asphalt-grey-040;\n      font-family: 'Inter Medium', sans-serif;\n      font-size: 0.75rem;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n    }\n\n    td:nth-child(2),\n    th:nth-child(2) {\n      width: 12rem;\n    }\n\n    td:nth-child(3),\n    th:nth-child(3) {\n      width: 14rem;\n    }\n\n    td:nth-child(4),\n    th:nth-child(4) {\n      width: 6rem;\n    }\n  }\n\n  .simulationProgressErrors {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    padding: @spacing-150;\n    border: 1px solid @color-asphalt-grey-090;\n    border-radius: @spacing-50;\n    background: @color-white;\n  }\n\n  .simulationProgressMeterList {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-50;\n  }\n\n  .simulationProgressMeterRow {\n    display: grid;\n    grid-template-columns: minmax(8rem, 14rem) 1fr 3rem;\n    align-items: center;\n    gap: @spacing-100;\n  }\n\n  .simulationProgressMeterTrack {\n    height: @spacing-50;\n    border-radius: @spacing-25;\n    background: @color-asphalt-grey-095;\n    overflow: hidden;\n  }\n\n  .simulationProgressMeterFill {\n    height: 100%;\n    border-radius: @spacing-25;\n  }\n\n  .simulationProgressErrorFill {\n    background: @color-orange-060;\n  }\n\n  .simulationProgressMeterCount {\n    text-align: right;\n  }\n\n  .simulationProgressLessonToggle {\n    display: flex;\n    align-items: center;\n    gap: @spacing-25;\n    padding: 0;\n    border: none;\n    background: none;\n    cursor: pointer;\n    text-align: left;\n    color: inherit;\n  }\n\n  .simulationProgressLessonTitle {\n    padding-left: calc(@spacing-100 + @spacing-25);\n  }\n\n  .simulationProgressLessonErrors td {\n    background: @color-asphalt-grey-099;\n    padding-left: calc(@spacing-75 + @spacing-100 + @spacing-25);\n  }\n\n  .simulationProgressLessonErrorList {\n    list-style: none;\n    margin: @spacing-50 0 0;\n    padding: 0;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));\n    gap: @spacing-50 @spacing-150;\n\n    li {\n      display: flex;\n      justify-content: space-between;\n      gap: @spacing-100;\n    }\n  }\n\n  .simulationOverview {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .header {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 20px;\n    }\n\n    .simulationDrivesWrapper {\n      margin-top: 20px;\n      height: calc(100vh - 300px);\n      overflow-y: auto;\n    }\n  }\n\n  .headerWithDropdown {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .overviewLayout {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .overviewContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: @spacing-100 @spacing-50 @spacing-200 0;\n    box-sizing: border-box;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .licenseSelectorContainer {\n    display: flex;\n    width: 280px;\n  }\n\n  .drivesWrapper {\n      overflow-y: scroll;\n  }\n\n    .theoryExamContainer {\n        overflow-y: scroll;\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        padding: 24px;\n        box-sizing: border-box;\n    }\n\n  .theoryProgressContainer {\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 12px;\n    width: 100%;\n    height: calc(100vh - 400px);\n    overflow-y: auto;\n    align-items: flex-start;\n    flex-wrap: nowrap;\n\n    // Ensure both components fit within the container\n    > * {\n      box-sizing: border-box !important;\n      flex-grow: 0;\n      flex-shrink: 0;\n    }\n\n    // TopicOverview - smaller width to ensure fit\n    > div:first-child {\n      width: 58% !important;\n      box-sizing: border-box !important;\n    }\n\n    // StudentProgressSummary - remaining space\n    > div:last-child {\n      width: 40% !important;\n      box-sizing: border-box !important;\n    }\n\n    // Stack components vertically on screens smaller than 1520px\n    @media (max-width: 1520px) {\n      display: block !important;\n      height: auto !important;\n\n      > div:first-child,\n      > div:last-child {\n        width: 100% !important;\n        display: block !important;\n        margin-bottom: 20px;\n      }\n\n      :global(.topicOverview) {\n        width: 100% !important;\n      }\n\n      > div:first-child > div:first-child {\n        width: 100% !important;\n      }\n    }\n  }\n\n  .scrollableContainer {\n    overflow-y: scroll;\n  }\n\n  // Ensure the scrollbar is visible in Webkit-based browsers (like Chrome)\n  .scrollableContainer::-webkit-scrollbar {\n    width: 8px; // Set the width of the scrollbar\n  }\n\n  .scrollableContainer::-webkit-scrollbar-thumb {\n    background-color: #c1c1c1; // Color of the scrollbar thumb\n    border-radius: 4px; // Rounded corners\n  }\n\n  .scrollableContainer::-webkit-scrollbar-thumb:hover {\n    background-color: #a1a1a1; // Darker color on hover\n  }\n\n  .scrollableContainer::-webkit-scrollbar-track {\n    background-color: #f1f1f1; // Background of the scrollbar track\n  }\n\n  .cards {\n    display: flex;\n    gap: @spacing-100;\n    margin: @spacing-50 @spacing-15;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"performance": `style__performance--BGTJg`,
	"box": `style__box--PLY7B`,
	"userPage": `style__userPage--az81f`,
	"userDetails": `style__userDetails--wQQKN`,
	"tabContentArea": `style__tabContentArea--r1TSC`,
	"userContentBox": `style__userContentBox--h60Mu`,
	"header": `style__header--b5Xva`,
	"headerMain": `style__headerMain--g3OT6`,
	"headerMainRow": `style__headerMainRow--lQURp`,
	"headerActions": `style__headerActions--ckMDO`,
	"headerAside": `style__headerAside--IW_OJ`,
	"headerAdminButtons": `style__headerAdminButtons--sSrpW`,
	"headerLicenseDropdown": `style__headerLicenseDropdown--OKYBt`,
	"headerInfo": `style__headerInfo--zpLR4`,
	"icon": `style__icon--PX86Q`,
	"scrollableUserContentBox": `style__scrollableUserContentBox--wO5bD`,
	"overview": `style__overview--hc7l1`,
	"chartsContainer": `style__chartsContainer--n3kyF`,
	"chartBox": `style__chartBox--FnfVG`,
	"smallBox": `style__smallBox--jlyl1`,
	"simulationProgressPage": `style__simulationProgressPage--eBes5`,
	"simulationProgress": `style__simulationProgress--jZkGd`,
	"simulationProgressHeader": `style__simulationProgressHeader--YOMVO`,
	"simulationProgressOverview": `style__simulationProgressOverview--ol9ts`,
	"simulationProgressSummary": `style__simulationProgressSummary--vuDAU`,
	"simulationProgressSummaryMain": `style__simulationProgressSummaryMain--_0j3A`,
	"simulationProgressPercent": `style__simulationProgressPercent--r55I4`,
	"simulationProgressSummaryText": `style__simulationProgressSummaryText--tl6NU`,
	"simulationProgressLastCompleted": `style__simulationProgressLastCompleted--IBwl8`,
	"simulationProgressStrip": `style__simulationProgressStrip--bma5Z`,
	"simulationProgressSegment": `style__simulationProgressSegment--AaOKL`,
	"simulationProgressStatusLabel": `style__simulationProgressStatusLabel--gsMXw`,
	"simulationProgressStatusDot": `style__simulationProgressStatusDot--jNanW`,
	"simulationProgressStatusCompleted": `style__simulationProgressStatusCompleted--cagcR`,
	"simulationProgressStatusFailed": `style__simulationProgressStatusFailed--L3noS`,
	"simulationProgressStatusInProgress": `style__simulationProgressStatusInProgress--LpVPu`,
	"simulationProgressStatusOpen": `style__simulationProgressStatusOpen--JiIVQ`,
	"simulationProgressStatusLocked": `style__simulationProgressStatusLocked--oGOg2`,
	"simulationProgressFilters": `style__simulationProgressFilters--GfRzk`,
	"simulationProgressTable": `style__simulationProgressTable--JOMOL`,
	"simulationProgressErrors": `style__simulationProgressErrors--fYF1K`,
	"simulationProgressMeterList": `style__simulationProgressMeterList--FI7D8`,
	"simulationProgressMeterRow": `style__simulationProgressMeterRow--wkSDH`,
	"simulationProgressMeterTrack": `style__simulationProgressMeterTrack--v1YY5`,
	"simulationProgressMeterFill": `style__simulationProgressMeterFill--HWGGQ`,
	"simulationProgressErrorFill": `style__simulationProgressErrorFill--E_m2D`,
	"simulationProgressMeterCount": `style__simulationProgressMeterCount--b5f2Y`,
	"simulationProgressLessonToggle": `style__simulationProgressLessonToggle--RmO8Q`,
	"simulationProgressLessonTitle": `style__simulationProgressLessonTitle--NdEJM`,
	"simulationProgressLessonErrors": `style__simulationProgressLessonErrors--qNMwW`,
	"simulationProgressLessonErrorList": `style__simulationProgressLessonErrorList--IOFIa`,
	"simulationOverview": `style__simulationOverview--u6uxf`,
	"simulationDrivesWrapper": `style__simulationDrivesWrapper--Lmf3C`,
	"headerWithDropdown": `style__headerWithDropdown--CdQpn`,
	"overviewLayout": `style__overviewLayout--pKv8J`,
	"overviewContent": `style__overviewContent--ap7r1`,
	"licenseSelectorContainer": `style__licenseSelectorContainer--KpUk7`,
	"drivesWrapper": `style__drivesWrapper--mGvpp`,
	"theoryExamContainer": `style__theoryExamContainer--k4HJ2`,
	"theoryProgressContainer": `style__theoryProgressContainer--tvEom`,
	"scrollableContainer": `style__scrollableContainer--eM5r9`,
	"cards": `style__cards--GeYof`
};
export default ___CSS_LOADER_EXPORT___;
